<template>
  <require from="framework/html_behaviors/af-autocomplete"></require>
  <require from="framework/html_behaviors/bs-tooltip"></require>
  <require from="framework/value_converters/empty-as-null"></require>

  <div class="form-group bs-form-lookup">
    <div class="bs-form-lookup-container">
      <input class="form-control ${controlClass} ${value ? '' : 'af-valuable--emptyvalue'}"
        type="text"
        placeholder.bind="placeholder"
        value.bind="value | emptyAsNull"
        disabled.bind="disabled"
        maxlength.bind="maxlength"
        af-autocomplete="options.bind: options; item.bind: item; value-path.bind: valuePath; stick-mode.bind: stickMode; template-path.bind: templatePath"
        focus.bind="hasfocus"
        blur.trigger="blur()"
        title="${tooltip && !value ? tooltip : ''}"
        data-placement="${tooltip && !value ? 'top' : ''}"
        bs-tooltip="${tooltip && !value ? true : false}" />
      <div if.bind="showLoading" class="bs-form-lookup-icon-container">
        <i class="fas fa-spinner sc-spin"></i>
      </div>
    </div>
    <small class="text-danger" if.bind="showEmptyResult">No results found.</small>
    <small class="form-label" repeat.for="label of labels">${label}</small>
  </div>
</template>
